import React, { FC } from 'react';
import styled from 'styled-components';
import { AlertHeader, Button, ModalContent, ModalHeader, ModalTitle, Text } from 'components';
import theme from 'design/theme';
import { IEmployee, IEmployerSite, IPOSProvider } from 'types';
import { ContentFooter, Layout, Wrapper } from '../styles';

const CustomerEmployeeIdText = styled(Text)`
  color: ${theme.color.neutral[500]};
`;

interface ISuccessProps {
  dataCy: string;
  title: string;
  provider: IPOSProvider | null;
  employee?: IEmployee;
  site?: IEmployerSite;
  onClose: () => void;
}

const Success: FC<ISuccessProps> = ({ title, provider, employee, site, onClose, dataCy }) => {
  const employeeName = employee?.name || provider.name;
  const employeeId = employee && site ? employee.sites.find((s) => s.id === site.id)?.employeeId : provider.customerEmployeeId;
  return (
    <Layout isActive onClose={onClose} maxWidth={540} data-cy={`${dataCy}-success`}>
      <ModalHeader>
        <ModalTitle data-cy="modal-title">{title}</ModalTitle>
      </ModalHeader>
      <ModalContent textAlign="center">
        <AlertHeader icon="Success" iconFill={theme.color.secondary[400]} />
        <Text fontWeight="bold">{employeeName}</Text>
        {employeeId && <CustomerEmployeeIdText size="small">Employee Id: {employeeId}</CustomerEmployeeIdText>}
        <Wrapper>
          <ContentFooter>
            <Button label="Review Payouts" onClick={onClose} />
          </ContentFooter>
        </Wrapper>
      </ModalContent>
    </Layout>
  );
};

export default Success;
